import axios from 'axios'

export default {
  list: (context, payload) => {
    const { commit } = context
    
    return new Promise((resolve, reject) => {
      axios.get('user', {
        params: payload,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          const { data } = response

          commit('setItems', data)
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  create: (_context, payload) => {
    return new Promise((resolve, reject) => {
      axios.post('user', payload)
        .then(response => {
          const { data } = response
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  edit: (_context, payload) => {
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.put(`user/${id}`, payload)
        .then(response => {
          const { data } = response
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
